import { useEffect, useState } from "react";
import apiClient from "../../../components/utils/apiClient";
import ReviewCard from "../../../components/workers/ReviewCard";
import { useTranslation } from "react-i18next";

const SingleTabReviews = ({workerId,setIsActionLoading}) => {
    const {t} = useTranslation();

    const [reviews, setReviews] = useState(null);

    const getReviews = async () => {
        try {
          const response = await apiClient.get(`/reviews?workerId=${workerId}`);
          if(response?.data) {
            setReviews(response?.data);
          } else {

          }
          setIsActionLoading(false);
        } catch(err) {setIsActionLoading(false);}
    }

    useEffect(()=>{
        setIsActionLoading(true);
        getReviews();
    },[])


    return (
        <> {reviews && (reviews?.length > 0 ? <div className="flex flex-wrap gap-[16px] mt-[24px]"> {reviews?.map((review,index)=>{
            return (<ReviewCard key={`review-${index}`} review={review} />)
        })}</div> : <div className="border-[1px] border-grey-200 rounded-[16px] px-[20px] py-[30px] my-[24px] bg-white text-center mt-[50px] max-w-[800px] mx-auto">{t('reviews.noReviews')}</div>)}
        </>
    )
}

export default SingleTabReviews;
